module.exports = __webpack_public_path__ + "fbStatic/fonts/iconfont.7664b269.ttf";